/**
 * Created by mark on 27/11/2017.
 */


import React  from 'react';
import AuthenticationServices from '../services/authenticate-services.js';
import AuthenticationStore    from '../store/authentication-store.js'
import CurriculumStore from '../store/curriculum-store.js';
import Layout from '../components/layouts/standard-page.js';
import ListItem from '../components/lists/list-item.js';
import Wizard from '../components/wizard/wizard.js';
import Steps  from '../components/wizard/create-class-steps';
import {Breadcrumb} from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import SubscriptionService from '../services/subscription-service.js';

export default class SubscriptionScreenComponent extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            user:{},
            products:[]
        }

    }

    componentDidMount(){
        AuthenticationServices.getUserData();
        SubscriptionService.vistPage();
    }

    componentWillMount(){
        AuthenticationStore.on("GET_USER_DATA" , () => {
            SubscriptionService.getProducts(AuthenticationStore.userData.package).then(function(response){
                console.log(response)
                this.setState({products :response || []});
            }.bind(this));
        });
    }

    subscriptionPanel(product){

        var list = [];

        for(var i = 0 ; i <  product.features.length; i++)
        {
            list.push(<li className="list-group-item"><i className="zmdi zmdi-check"></i> {product.features[i].text}</li>);
        }

        return <div className="col-md-4 text-center">
            <div className="panel panel-pricing">
                <div className="panel-heading">
                    <i className="fa fa-desktop"></i>
                    <h3>{product.name}</h3>
                    <h4>{product.sub_title}</h4>
                </div>
                <div className="panel-body text-center">
                    <small><strong>{product.price}</strong></small>
                </div>
                <ul className="list-group text-center">
                    {list}
                </ul>
                <div className="panel-footer">
                    <a className="btn btn-lg btn-block btn-primary" href={product.link}><b>Contact Us</b></a>
                </div>
            </div>
        </div>
    }

    subscriptionPanels(){

        var response = [];
        for(var idx = 0 ; idx < this.state.products.length; idx++){

            var product = this.state.products[idx];

            response.push(this.subscriptionPanel(product))
        }

        return response;
    }

    render(){

        return <Layout>{this.subscriptionPanels()}</Layout>

    }
}


// WEBPACK FOOTER //
// ./src/screens/subscription.js